var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.50005 10.9173C6.18766 10.9182 6.80034 10.4834 7.02647 9.83398H3.97363C4.19976 10.4834 4.81244 10.9182 5.50005 10.9173ZM9.29167 6.9014V4.41732C9.29167 2.67478 8.10813 1.20686 6.50479 0.765401C6.34609 0.365651 5.95825 0.0839844 5.5 0.0839844C5.04175 0.0839844 4.65392 0.365651 4.49521 0.765401C2.89188 1.2074 1.70833 2.67478 1.70833 4.41732V6.9014L0.783709 7.82603C0.681917 7.92745 0.624792 8.06529 0.625001 8.20899L0.625 8.75065C0.625 9.04981 0.867513 9.29232 1.16667 9.29232H9.83333C10.1325 9.29232 10.375 9.04981 10.375 8.75065V8.20899C10.3752 8.0653 10.3181 7.92746 10.2163 7.82603L9.29167 6.9014Z",
    fill: "#444F59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.4257c699ee7778ef7a8ca8fafca41526.svg";
export { ForwardRef as ReactComponent };